import React from 'react';
import { Grid } from '@material-ui/core';
import useStyles from '../common/Styles';
import ChartTogglebar from '../common/ChartTogglebar';
import AboutTogglebar from '../common/AboutTogglebar';
import ChartView from './ChartView';
import { charts, about } from './constants';
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import IndustryMetric from './IndustryMetric';

const IndustryView = () => {
    const classes = useStyles();
    // const [chart, setChart] = React.useState(0);
    const { chart_selected } = useSelector((state) => state.water_user);
    const { setWaterUserChart } = userActions();
    
    const handleChange = (e, idx) => {
        setWaterUserChart(idx);
      };

    return (
        <Grid container item className={classes.mainView}>
            <ChartTogglebar 
                charts={charts} value={chart_selected >= charts.length ? 0 : chart_selected} 
                // onChange={ (event, value) => setChart(value) } 
                onChange={(event, value) => handleChange(event, value)}
                setChart={setWaterUserChart} 
            />
            <ChartView chart={charts[chart_selected >= charts.length ? 0 : chart_selected]} />
            <AboutTogglebar metrics={ charts[chart_selected >= charts.length ? 0 : chart_selected].metrics } MetricsComponent={ (chart_selected >= charts.length ? 0 : chart_selected)===0? <IndustryMetric /> : undefined } about={about[chart_selected >= charts.length ? 0 : chart_selected]} />
        </Grid>
    );
};

export default IndustryView;

